
import { Badge } from "@/components/ui/badge";

interface CallIntentSectionProps {
  intentSummary: string | null;
  intentScore: number | null;
}

export const CallIntentSection = ({ intentSummary, intentScore }: CallIntentSectionProps) => {
  const getIntentScoreBadgeVariant = (): "success" | "default" | "outline" => {
    if (!intentScore) return "outline";
    if (intentScore > 80) return "success";
    return "default";
  };
  
  return (
    <div>
      <h3 className="text-sm font-medium mb-2">Intent Analysis</h3>
      {intentSummary ? (
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <span className="font-medium">Intent Score:</span>
            <Badge variant={getIntentScoreBadgeVariant()}>
              {intentScore || "N/A"}
            </Badge>
          </div>
          <div className="bg-muted/20 rounded-md p-4 text-sm">
            <p className="whitespace-pre-line">{intentSummary}</p>
          </div>
        </div>
      ) : (
        <div className="bg-muted/20 rounded-md p-4 text-sm text-muted-foreground text-center py-8">
          <p>No intent analysis available for this call yet</p>
        </div>
      )}
    </div>
  );
};
